import { SVGProps } from "react";

const GIFlask = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="1em" height="1em" {...props}><circle cx={128} cy={128} r={128} /><circle stroke="#fff" strokeWidth={18} cx={128} cy={128} r={101} /><path fill="#fff" d="M96 63v16h16v16c0 16-32 54-32 86 0 16 96 16 96 0 0-32-32-70-32-86V79h16V63z" /></svg>;

export { GIFlask };